module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAEBJREFUKBVjYMAC/v//bwDCWKSwCwEVHwBhbLJM2ATxidFeAyPUcxPQnAHz8AU08QKSnYRmAIQ7xEIJlx9wJg0A2xAg5aFVkNQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/icon_plus_white_12_12.png
// module id = ./src/_asset/sources/assets/images/icon_plus_white_12_12.png
// module chunks = main